import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import LandingLayout from "../../../layout/LandingLayout";
import { theme } from "../../../theme/theme";
import DocumentViewerModal from "../../../components/Common/DocumentViewerModal";
import DocumentFilePreview from "../../../components/Common/DocumentFilePreview";
import { getAllDocuments } from "../../../redux/dispatchers/documents.dispatcher";

const LandingDocuments = () => {
  const dispatch = useDispatch();
  const { allDocuments } = useSelector((state) => state.documents);
  const documents = allDocuments || [];
  const [selectedDocument, setSelectedDocument] = useState(null);

  useEffect(() => {
    dispatch(getAllDocuments());
  }, [dispatch]);

  return (
    <LandingLayout>
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Bold",
          fontSize: "24px",
          mb: 3,
        }}
      >
        Documents
      </Typography>

      {documents.length === 0 ? (
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
          }}
        >
          No documents available.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {documents.map((doc) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={doc.id}>
              <Box
                onClick={() => setSelectedDocument(doc)}
                sx={{
                  borderRadius: "14px",
                  overflow: "hidden",
                  border: theme.lightBorder,
                  backgroundColor: "rgba(255,255,255,0.03)",
                  cursor: "pointer",
                }}
              >
                {doc.cover_url ? (
                  <Box
                    component="img"
                    src={doc.cover_url}
                    alt={doc.title}
                    sx={{
                      width: "100%",
                      height: "140px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <DocumentFilePreview fileName={doc.file_name} height="140px" />
                )}
                <Box sx={{ p: 2 }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: "Mulish-SemiBold",
                      fontSize: "15px",
                      mb: 0.5,
                    }}
                  >
                    {doc.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "12px",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {doc.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}

      <DocumentViewerModal
        open={Boolean(selectedDocument)}
        onClose={() => setSelectedDocument(null)}
        document={selectedDocument}
      />
    </LandingLayout>
  );
};

export default LandingDocuments;
